import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import ListSubheader from "@mui/material/ListSubheader";
import List from "@mui/material/List";
import MenuHeader from "../MenuHeader";
import MenuItem from "../MenuItem";
import { MenuItemType } from "@beyondrealityapp/core/shared/types";

type MenuViewProps = {
  open: boolean;
  onClose: () => void;
  onOpen: () => void;
  checkIfActiveMenuItems: (menuItems: MenuItemType[]) => boolean;
  knowYourselfMenuItems: MenuItemType[];
  becomeYourselfMenuItems: MenuItemType[];
  communityMenuItems: MenuItemType[];
  showAdminPanel: boolean;
  adminPanelMenuItems: MenuItemType[];
};

const MenuView: React.FC<MenuViewProps> = ({
  open,
  onClose,
  onOpen,
  checkIfActiveMenuItems,
  knowYourselfMenuItems,
  becomeYourselfMenuItems,
  communityMenuItems,
  showAdminPanel,
  adminPanelMenuItems,
}) => {
  return (
    <SwipeableDrawer
      anchor="left"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      sx={{
        "& .MuiListSubheader-root": {
          backgroundColor: "background.default",
        },
        "& .Mui-selected": {
          borderTopRightRadius: 24,
          borderBottomRightRadius: 24,
          paddingRight: 4,
          marginRight: 2,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          height: "100%",
        }}
      >
        <Box>
          <MenuHeader onClose={onClose} />
          <Divider />
        </Box>
        <List>
          {checkIfActiveMenuItems(knowYourselfMenuItems) && (
            <>
              <ListSubheader>Know Yourself</ListSubheader>
              {knowYourselfMenuItems.map(
                (menuItem) =>
                  menuItem.active && (
                    <MenuItem
                      key={menuItem.text}
                      text={menuItem.text}
                      icon={menuItem.icon}
                      path={menuItem.path}
                      onClose={onClose}
                    />
                  )
              )}
            </>
          )}
          {checkIfActiveMenuItems(becomeYourselfMenuItems) && (
            <>
              <Divider />
              <ListSubheader>Become yourself</ListSubheader>
              {becomeYourselfMenuItems.map(
                (menuItem) =>
                  menuItem.active && (
                    <MenuItem
                      key={menuItem.text}
                      text={menuItem.text}
                      icon={menuItem.icon}
                      path={menuItem.path}
                      onClose={onClose}
                    />
                  )
              )}
            </>
          )}
          {checkIfActiveMenuItems(communityMenuItems) && (
            <>
              <Divider />
              <ListSubheader>Community</ListSubheader>
              {communityMenuItems.map((menuItem) => (
                <MenuItem
                  key={menuItem.text}
                  text={menuItem.text}
                  icon={menuItem.icon}
                  path={menuItem.path}
                  onClose={onClose}
                />
              ))}
            </>
          )}
          {showAdminPanel && (
            <>
              <Divider />
              <ListSubheader>Site controls</ListSubheader>
              {adminPanelMenuItems.map((menuItem) => (
                <MenuItem
                  key={menuItem.text}
                  text={menuItem.text}
                  icon={menuItem.icon}
                  path={menuItem.path}
                  onClose={onClose}
                />
              ))}
            </>
          )}
        </List>
      </Box>
    </SwipeableDrawer>
  );
};

export default MenuView;
